var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalStatusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23684,
    cy: 7.23684,
    r: 7.23684,
    fill: "#61BB57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6821 4.73454C12.0385 5.09104 12.0385 5.66903 11.6821 6.02552L7.84419 9.86339C7.30945 10.3981 6.44246 10.3981 5.90772 9.86339L3.29912 7.25479C2.94263 6.8983 2.94263 6.32031 3.29912 5.96381C3.65562 5.60732 4.23361 5.60732 4.5901 5.96381L6.87595 8.24966L10.3911 4.73454C10.7476 4.37805 11.3256 4.37805 11.6821 4.73454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalStatusActive);
export default __webpack_public_path__ + "static/media/modal-status-active.f57f0da533af3acdfc42dd7de730f3b8.svg";
export { ForwardRef as ReactComponent };